import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wo_030",
  "use": "icon-wo_030-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-wo_030\"><defs><style>#icon-wo_030 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-wo_030_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-wo_030_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><path class=\"cls-2\" d=\"M19.55,5.45A10,10,0,0,0,2.2,10H4.27A8,8,0,0,1,18.12,6.88L15,10h7L22,3Z\" /><path class=\"cls-2\" d=\"M19.73,14A8,8,0,0,1,5.88,17.12L9,14H2.05l0,7,2.45-2.45A10,10,0,0,0,21.8,14Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol